import { registerLocaleData } from '@angular/common';
import es from '@angular/common/locales/es';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';

import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Store } from '@ngrx/store';

import { PositionSummary } from '../../models/positions.model';
import {
	cloneOrgPositionClear,
	cloneOrgPositionStart,
	deleteOrgPositionStart,
	deleteStepClear,
	fetchOrgPositionsClear,
	fetchOrgPositionsStart,
} from '../../state/organizations.actions';
import {
	selectDeleteStep,
	selectOrgLoading,
	selectPositionCloneId,
	selectPositions,
} from '../../state/organizations.selector';

@Component({
	selector: 'app-del-position-dialog',
	template: `
		<app-dialog
			modalTitle="Atenção"
			titleButton="Sim"
			secTitleButton="Não"
			[secButton]="true"
			[asAlert]="true"
			(dialogClose)="dialogRef.close(false)"
			(dialogSave)="dialogRef.close(true)"
		>
			<p class="lh-md">
				A exclusão desse cargo pode afetar alguns beneficiários que possuem este
				cargo. Tem certeza que deseja continuar?
			</p>
		</app-dialog>
	`,
})
export class DelPositionDialogComponent {
	constructor(public dialogRef: MatDialogRef<DelPositionDialogComponent>) {}
}

@Component({
	selector: 'app-positions',
	styleUrls: ['./positions.component.scss'],
	templateUrl: './positions.component.html',
})
export class PositionsComponent implements OnInit, OnDestroy {
	alertRef!: MatDialogRef<DelPositionDialogComponent>;
	loading: boolean = true;
	loading$: Observable<boolean>;
	positions: PositionSummary[] = [];
	private orgId: string = '';

	private readonly unsubscribe$: Subject<void> = new Subject();

	constructor(
		private readonly router: Router,
		private readonly activatedRoute: ActivatedRoute,
		private readonly dialog: MatDialog,
		private readonly store: Store,
	) {
		this.loading$ = this.store.select(selectOrgLoading);
	}

	ngOnDestroy(): void {
		this.unsubscribe$.next();
		this.unsubscribe$.complete();
		this.store.dispatch(fetchOrgPositionsClear());
	}

	ngOnInit(): void {
		registerLocaleData(es);
		this.activatedRoute.params.subscribe(({ id }) => {
			if (id) {
				this.orgId = id;
				this.store.dispatch(fetchOrgPositionsStart({ id: this.orgId }));
				this.store
					.select(selectPositions)
					.pipe(takeUntil(this.unsubscribe$))
					.subscribe((pos) => {
						if (pos) {
							this.positions = pos;
							this.loading = false;
						}
					});
			}
		});
	}

	onClonePosition(id: string): void {
		this.store
			.select(selectPositionCloneId)
			.pipe(takeUntil(this.unsubscribe$))
			.subscribe((cloneId) => {
				if (!(!cloneId || !this.orgId)) {
					this.router.navigateByUrl(
						`organizacoes/${this.orgId}/cargos/${cloneId}`,
					);
					this.store.dispatch(cloneOrgPositionClear());
				}
			});
		this.store.dispatch(
			cloneOrgPositionStart({ id: this.orgId, request: { id } }),
		);
	}

	onDeletePosition(id: string): void {
		this.alertRef = this.dialog.open(DelPositionDialogComponent, {
			disableClose: true,
			maxWidth: undefined,
		});
		this.alertRef.afterClosed().subscribe((result) => {
			if (result) {
				this.store
					.select(selectDeleteStep)
					.pipe(takeUntil(this.unsubscribe$))
					.subscribe((step) => {
						if (step === 1) {
							this.store.dispatch(deleteStepClear());
							this.store.dispatch(fetchOrgPositionsStart({ id: this.orgId }));
						}
					});
				this.store.dispatch(deleteOrgPositionStart({ id, orgId: this.orgId }));
			}
		});
	}

	onEditPosition(id: string): void {
		if (this.orgId) {
			this.router.navigateByUrl(`organizacoes/${this.orgId}/cargos/${id}`);
		}
	}
}
